import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CalendarClock, Video, Users } from "lucide-react";
import { Link } from "react-router-dom";

// Reusable widget: "Próximas 3 sesiones" for alumno/instructor/staff dashboards.
// Pass ownerType "instructor" to hit /instructor/sessions or "alumno" for /alumno/calendar.
export default function UpcomingSessionsWidget({ ownerType = "alumno", limit = 3 }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const endpoint = ownerType === "instructor" ? "/instructor/sessions" : "/alumno/calendar";
    const from = new Date().toISOString();
    api.get(endpoint, { params: { from_: from } })
      .then((r) => setItems((r.data.items || []).slice(0, limit)))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [ownerType, limit]);

  if (loading) return null;
  if (items.length === 0) {
    return (
      <div className="p-4 rounded-2xl bg-white/5 border border-white/10" data-testid={`upcoming-sessions-${ownerType}-empty`}>
        <div className="flex items-center gap-2 mb-2">
          <CalendarClock className="w-4 h-4 text-[#F26A21]" />
          <h3 className="text-sm font-bold text-white">Próximas sesiones</h3>
        </div>
        <p className="text-xs text-gray-500">Sin sesiones próximas.</p>
      </div>
    );
  }

  return (
    <div className="p-4 rounded-2xl bg-white/5 border border-white/10" data-testid={`upcoming-sessions-${ownerType}`}>
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <CalendarClock className="w-4 h-4 text-[#F26A21]" />
          <h3 className="text-sm font-bold text-white">Próximas sesiones</h3>
        </div>
        <Link to={ownerType === "instructor" ? "/app/instructor/calendario" : "/app/alumno/calendario"}
          className="text-[10px] uppercase tracking-widest text-[#F26A21] hover:text-[#D9541A]">
          Ver todo
        </Link>
      </div>
      <ul className="space-y-2">
        {items.map((s) => (
          <li key={s.id} className="p-3 rounded-lg bg-black/30 border border-white/5" data-testid={`upcoming-item-${s.id}`}>
            <div className="flex items-start justify-between gap-2">
              <div className="flex-1 min-w-0">
                <p className="text-xs font-semibold text-white truncate">{s.title}</p>
                <p className="text-[10px] text-gray-400 mt-0.5">
                  {new Date(s.starts_at).toLocaleString("es-MX", { dateStyle: "medium", timeStyle: "short" })} · {s.duration_min}min
                </p>
              </div>
              {s.meeting_url && s.meeting_url.startsWith("/live/") && (
                <Link to={s.meeting_url} className="text-[#F26A21] p-1" title="Sala DCC">
                  <Video className="w-3 h-3" />
                </Link>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
